<template>
  <div class="show-more">
    <a
      href="#"
      v-on:mouseover="mouseover"
      v-on:mouseleave="mouseleave"
      @click.prevent="toPage"
      :class="this.info.class"
    ></a>
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      v-if="this.info.class == 'rect'"
      ref="svg"
    >
      <path d="M0 0H5V5H0V0Z" fill="#283891" class="rect-path rect1" />
      <path d="M7 0H12V5H7V0Z" fill="#283891" class="rect-path rect2" />
      <path d="M7 7H12V12H7V7Z" fill="#283891" class="rect-path rect3" />
      <path d="M0 7H5V12H0V7Z" fill="#283891" class="rect-path rect4" />
    </svg>
    <svg
      width="12"
      height="13"
      viewBox="0 0 12 13"
      fill="none"
      v-else-if="this.info.class == 'line' "
    >
      <path d="M0 0H12V3H0V0Z" fill="#283891" class="line-path line1" />
      <path d="M0 5H12V8H0V5Z" fill="#283891" class="line-path line2" />
      <path d="M0 10H12V13H0V10Z" fill="#283891" class="line-path line3" />
    </svg>
    <svg width="12" height="13" viewBox="0 0 12 13" fill="none" v-else>
      <path d="M0 0H12V3H0V0Z" fill="#283891" class="line-end-path lineEnd1" />
      <path d="M0 5H12V8H0V5Z" fill="#283891" class="line-end-path lineEnd2" />
      <path d="M0 10H8V13H0V10Z" fill="#283891" class="line-end-path lineEnd3" />
    </svg>
    <h6 :class="this.info.class">{{this.info.text ? this.info.text : this.text}}</h6>
  </div>
</template>
<script>
import { TweenMax, TimelineMax, Back, Power3 } from "gsap";

let tlRect = new TimelineMax();
let tlLine = new TimelineMax();
let tlLineEnd = new TimelineMax();

export default {
  props: {
    info: Object
  },
  data() {
    return {
      url: "/",
      text: "Show more"
    };
  },
  methods: {
    toPage() {
      if (this.info.url) {
        this.$router.push({ path: `${this.info.url}` });
      }
    },
    rect() {
      var rect1 = document.querySelector("svg.active .rect1");
      var rect2 = document.querySelector("svg.active .rect2");
      var rect3 = document.querySelector("svg.active .rect3");
      var rect4 = document.querySelector("svg.active .rect4");
      tlRect.set("svg.active .rect-path", { opacity: 0 });
      tlRect.to(rect1, 0.1, { opacity: 1 }, "+=0.1");
      tlRect.to(rect2, 0.1, { opacity: 1 }, "+=0.1");
      tlRect.to(rect1, 0.1, { opacity: 0 }, "-=0.1");
      tlRect.to(rect3, 0.1, { opacity: 1 }, "+=0.1");
      tlRect.to(rect2, 0.1, { opacity: 0 }, "-=0.1");
      tlRect.to(rect4, 0.1, { opacity: 1 }, "+=0.1");
      tlRect.to(rect3, 0.1, { opacity: 0 }, "-=0.1");

      tlRect.to(rect1, 0.1, { opacity: 1 }, "+=0.1");
      tlRect.to(rect2, 0.1, { opacity: 1 }, "+=0.1");
      tlRect.to(rect1, 0.1, { opacity: 0 }, "-=0.1");
      tlRect.to(rect3, 0.1, { opacity: 1 }, "+=0.1");
      tlRect.to(rect2, 0.1, { opacity: 0 }, "-=0.1");

      tlRect.to(rect1, 0.1, { opacity: 1 }, "+=0.1");
      tlRect.to(rect2, 0.1, { opacity: 1 }, "+=0.1");
      tlRect.to(rect1, 0.1, { opacity: 0 }, "-=0.1");

      tlRect.to(rect1, 0.1, { opacity: 1 }, "+=0.1");

      tlRect.set(rect1, { opacity: 1 }, "+=0.1");
    },
    line() {
      var line1 = document.querySelector("svg.active .line1");
      var line2 = document.querySelector("svg.active .line2");
      var line3 = document.querySelector("svg.active .line3");

      tlLine.set("svg.active .line-path", { opacity: 0 });
      tlLine.to(line1, 0.1, { opacity: 1 }, "+=0.1");
      tlLine.to(line2, 0.1, { opacity: 1 }, "+=0.1");
      tlLine.to(line1, 0.1, { opacity: 0 }, "-=0.1");
      tlLine.to(line3, 0.1, { opacity: 1 }, "+=0.1");
      tlLine.to(line2, 0.1, { opacity: 0 }, "-=0.1");

      tlLine.to(line1, 0.1, { opacity: 1 }, "+=0.1");
      tlLine.to(line2, 0.1, { opacity: 1 }, "+=0.1");
      tlLine.to(line1, 0.1, { opacity: 0 }, "-=0.1");

      tlLine.to(line1, 0.1, { opacity: 1 }, "+=0.1");

      tlLine.set(line1, { opacity: 1 }, "+=0.1");
    },
    lineEnd() {
      var lineEnd1 = document.querySelector("svg.active .lineEnd1");
      var lineEnd2 = document.querySelector("svg.active .lineEnd2");
      var lineEnd3 = document.querySelector("svg.active .lineEnd3");

      tlLineEnd.set("svg.active .line-end-path", { opacity: 0 });
      tlLineEnd.to(lineEnd1, 0.1, { opacity: 1 }, "+=0.1");
      tlLineEnd.to(lineEnd2, 0.1, { opacity: 1 }, "+=0.1");
      tlLineEnd.to(lineEnd1, 0.1, { opacity: 0 }, "-=0.1");
      tlLineEnd.to(lineEnd3, 0.1, { opacity: 1 }, "+=0.1");
      tlLineEnd.to(lineEnd2, 0.1, { opacity: 0 }, "-=0.1");

      tlLineEnd.to(lineEnd1, 0.1, { opacity: 1 }, "+=0.1");
      tlLineEnd.to(lineEnd2, 0.1, { opacity: 1 }, "+=0.1");
      tlLineEnd.to(lineEnd1, 0.1, { opacity: 0 }, "-=0.1");

      tlLineEnd.to(lineEnd1, 0.1, { opacity: 1 }, "+=0.1");

      tlLineEnd.set(lineEnd1, { opacity: 1 }, "+=0.1");
    },
    mouseover: function(e) {
      if (
        e.target.className == "rect" ||
        e.target.parentElement.className == "rect"
      ) {
        e.target.nextSibling.classList.add("active");
        this.rect();
      } else if (
        e.target.className == "line" ||
        e.target.parentElement.className == "line"
      ) {
        e.target.nextSibling.classList.add("active");
        this.line();
      } else if (
        e.target.className == "line-end" ||
        e.target.parentElement.className == "lineEnd"
      ) {
        e.target.nextSibling.classList.add("active");
        this.lineEnd();
      }
    },
    mouseleave() {
      var svgActive = document.querySelectorAll(".show-more svg.active");
      svgActive.forEach(element => {
        element.classList.remove("active");
      });

      tlRect.clear();
      tlRect.set(".rect-path", { opacity: 1 });

      tlLine.clear();
      tlLine.set(".line-path", { opacity: 1 });

      tlLineEnd.clear();
      tlLineEnd.set(".line-end-path", { opacity: 1 });
    }
  }
};
</script>
<style lang="scss" scoped>
$blue: #283891;
$orange: #fbbb00;

.show-more {
  cursor: pointer;
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  position: relative;
  a {
    position: absolute;
    cursor: pointer;
    width: 100%;
    height: 100%;
    display: inline-block;
  }
  svg {
    display: inline-block;
    width: 1.2rem;
    margin-right: 1rem;
  }
  &.blue {
    h6 {
      color: $blue;
    }
    svg {
      path {
        fill: $blue;
      }
    }
  }
  &.orange {
    h6 {
      color: $orange;
    }
    svg {
      path {
        fill: $orange;
      }
    }
  }

  &.line {
    span {
      height: 1.3rem;
    }
  }

  &.rect {
    path {
      transition: all 0.1s ease-in-out;
    }
  }
}
</style>